@if (moneybarData) {
  <div class="o100w-moneybar-root">
    <div class="o100w-goal-indicator">
      <div class="o100w-goal-indicator-pointer"></div>
    </div>
    <div class="o100w-moneybar-container">
      <div class="o100w-moneybar-information-container">
        <div class="o100w-moneybar-grouplabel">
          <span class="o100w-moneybar-grouplabel-code">
            {{ moneybarData.beneficiaryGroup.code }}
            ({{ moneybarData.beneficiaryGroup.status.description | lowercase }}) | opened:
            {{ (moneybarData.beneficiaryGroup.moneybarOpenedDate | date: 'yyyy-MM-dd') || '-' }}
            | closed:
            {{ (moneybarData.beneficiaryGroup.moneybarClosedDate | date: 'yyyy-MM-dd') || '-' }}
          </span>
          @if (moneybarData.beneficiaryGroup.localName) {
            <span class="o100w-moneybar-grouplabel-name">
              {{ moneybarData.beneficiaryGroup.localName }}
            </span>
          }
        </div>
        <div class="o100w-goal-meter">
          <span slot="start"
            >{{ moneybarData.donated + moneybarData.presentValueOfFuturePayments | currency: 'EUR' }}/</span
          >
          <span slot="end" class="o100w-moneybar-text-light">{{ goalDisplayValue() }}</span>
        </div>
      </div>
      <div class="o100w-moneybar">
        <div class="o100w-moneybar-goal">
          @if (moneybarData.donated) {
            <div
              class="o100w-moneybar-part o100w-moneybar-part--donated"
              [style]="'flex: 0 0 ' + donatedWidth() + '%'"
              [matTooltip]="'Already donated: ' + donatedDisplayValue()"
            ></div>
          }
          @if (moneybarData.presentValueOfFuturePayments) {
            <div
              class="o100w-moneybar-part o100w-moneybar-part--discounted"
              [style]="'flex: 0 0 ' + discountedWidth() + '%'"
              [matTooltip]="'Expected donations: ' + discountedDisplayValue()"
            ></div>
          }
          <div
            class="o100w-moneybar-part o100w-moneybar-part--togo"
            [style]="'flex: 0 0 ' + shortOfGoalWidth() + '%'"
            [matTooltip]="shortOfGoalDisplayValue() + ' away from ' + goalDisplayValue()"
          ></div>
        </div>
        <div class="o100w-moneybar-buffer">
          <div
            class="o100w-moneybar-part o100w-moneybar-part--buffer"
            [style]="'flex: 0 0 ' + bufferWidth() + '%; margin-left: ' + overshootWidth() + '%;'"
            [matTooltip]="'Buffer: ' + bufferValue()"
          ></div>
        </div>
      </div>
    </div>
  </div>
}
